import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

// Shared shell for internal routed pages: dark header offset + footer.
export default function PageShell({ children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Header solid />
      <main className="flex-1 pt-[109px]">{children}</main>
      <Footer />
    </div>
  );
}

export function PageHero({ eyebrow, title, intro, stat }) {
  return (
    <section className="bg-[#0b1f3a] relative overflow-hidden py-16 md:py-24">
      <div className="pointer-events-none absolute -top-16 -right-16 w-[420px] h-[420px] rounded-full border border-[#c2a15a]/12" />
      <div className="pointer-events-none absolute top-6 -right-6 w-[300px] h-[300px] rounded-full border border-[#c2a15a]/10" />
      <div className="max-w-5xl mx-auto px-5 md:px-8 relative z-10">
        {eyebrow && (
          <p className="text-[#c2a15a] text-[13px] tracking-[0.25em] uppercase mb-4">
            {eyebrow}
          </p>
        )}
        <h1 className="font-display text-white text-[38px] md:text-[56px] leading-[1.08] max-w-3xl">
          {title}
        </h1>
        {intro && (
          <p className="text-white/70 text-[17px] md:text-[19px] leading-relaxed max-w-2xl mt-6">
            {intro}
          </p>
        )}
        {stat && (
          <div className="mt-8 inline-flex items-baseline gap-3 rounded-xl bg-white/[0.05] ring-1 ring-[#c2a15a]/25 px-6 py-4">
            <span className="font-display text-[#c2a15a] text-[34px] leading-none">
              {stat.value}
            </span>
            <span className="text-white/60 text-[14px]">{stat.label}</span>
          </div>
        )}
      </div>
    </section>
  );
}
